/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 **/
export const DATABASE_RESOURCES = {
  DB_CONTENTSECTION: 'db_contentsection',
  DB_SECTIONCONTENT: 'db_sectioncontent',
  DB_CONTENTINTERACTION: 'db_contentinteraction',
  DB_LEARNINGMODULE: 'db_learningmodule',
  DB_LEARNINGPHASE: 'db_learningphase',
  DB_LEARNINGTASK: 'db_learningtask',
  DB_LEARNINGMODULEPHASE: 'db_learningmodulephase',
  DB_LEARNINGPHASETASK: 'db_learningphasetask',
  DB_LEARNINGTASKVERSION: 'db_learningtaskversion',
  DB_LEARNINGTASKASSET: 'db_learningtaskasset',
  DB_LEARNINGTASKASSETLINK: 'db_learningtaskassetlink',
  DB_LEARNINGPREREQUISITE: 'db_learningprerequisite',
  DB_LEARNINGTAG: 'db_learningtag',
  DB_LEARNINGTASKTAG: 'db_learningtasktag',
  DB_LEARNINGQUIZZE: 'db_learningquizze',
  DB_LEARNINGTASKQUIZZE: 'db_learningtaskquizze',
  DB_LEARNINGQUIZQUESTION: 'db_learningquizquestion',
  DB_LEARNINGQUIZATTEMPT: 'db_learningquizattempt',
  DB_LEARNINGTASKSECTION: 'db_learningtasksection',
  DB_LEARNINGTASKSECTIONLINK: 'db_learningtasksectionlink',
  DB_LEARNINGSECTIONCONTENT: 'db_learningsectioncontent',
  DB_LEARNINGPROGRES: 'db_learningprogres',
  DB_ROLERESOURCEPERMISSION: 'db_roleresourcepermission',
  DB_ROLE: 'db_role',
  DB_TENANT: 'db_tenant',
  DB_USERROLE: 'db_userrole',
  DB_USER: 'db_user',
} as const;